export default "__VITE_ASSET__CzYQFA0$__"